import { styled } from "@mui/system";
import { Button } from "@mui/material";

type SButtonProps = {
  customColor?: string;
  customBackgroundColor?: string;
};

export const StyledPillButton = styled(Button, {
  shouldForwardProp: (prop) =>
    prop !== "customColor" && prop !== "customBackgroundColor",
})<SButtonProps>(({ theme, customColor, customBackgroundColor }) => ({
  backgroundColor: customBackgroundColor || theme.palette.background.default,
  borderRadius: "40px",
  border: `1px solid ${theme.palette.text.primary}`,
  color: customColor || theme.palette.text.primary,
  fontWeight: "bold",
  lineHeight: "1",
  "&:hover": {
    background: theme.palette.accent.background,
  },
}));
